// PrivacyPage — renders docs/privacy.md as a public, no-auth page.
// Route: /privacy (public, outside RequireAuth)
import content from '../../../docs/privacy.md?raw';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-2xl px-6 py-12">
        <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed text-foreground">
          {content}
        </pre>
      </div>
    </div>
  );
}
